import { JSRegister, JSCallNative } from '@lyh/jsbridge'

let appshare = (res) => {
  JSCallNative('showRightNavigationBarButton')
  JSRegister('shareDoc', (data, callback) => {
    callback({
      param: {
        text: '研值圈',
        title: res.title,
        image: res.imgUrl,
        url: res.link
      }
    })
  })
}

export default appshare
